import { html } from "uhtml";
import { locales } from "../../models/locales.js";
import { openCloseToggle } from "./openCloseToggle.js";
import { readerToolBar } from "./readerToolBar.js";

export function topNavigation(locale, showNavigation) {
	return html`<div role="banner" class="publication top-bar" aria-label="${
		locales.controlPanel[locale]
	}" lang="${locale}">
${openCloseToggle(locale)}
${readerToolBar(showNavigation)}</div>`;
}
